import {
    EventBus
} from '@/eventBus';

export default function (Vue) {
    const hasValidUserId = (userId) => {
        if (userId === null || typeof userId === 'undefined') {
            return false;
        }

        const normalizedUserId = String(userId).trim().toLowerCase();

        return normalizedUserId !== '' && normalizedUserId !== 'null' && normalizedUserId !== 'undefined';
    };

    Vue.auth = {
        setToken(token) {
            localStorage.setItem('token', token);

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow = Math.round(+tomorrow / 1000);
            localStorage.setItem('expiration', tomorrow);
        },

        setUser(username, type, userId) {
            localStorage.setItem('username', username);
            localStorage.setItem('type', type);

            if (hasValidUserId(userId)) {
                localStorage.setItem('user_id', String(userId));
                return;
            }

            localStorage.removeItem('user_id');
        },

        setRequestType(type) {
            localStorage.setItem('request_type', type)
        },

        getRequestType() {
           let type = localStorage.getItem('request_type');
           if (!type) {
               return null;
           }

           return type;
        },

        setSessionId(session_id) {
            document.cookie = `session_id=${session_id}`;
            localStorage.setItem('session_id', session_id);
        },

        getUser() {
            return {
                username: localStorage.getItem('username'),
                type: localStorage.getItem('type'),
                user_id: localStorage.getItem('user_id'),
            }
        },

        getToken() {
            let token = localStorage.getItem('token');
            let expiration = localStorage.getItem('expiration');

            if (!token || !expiration) return null;
            if (Math.round(new Date().getTime() / 1000) > expiration) {
                this.destroyToken();
                return null;
            }

            return token;
        },

        destroyToken() {
            EventBus.$emit('logout-user');
            localStorage.removeItem('token');
            localStorage.removeItem('expiration');
            localStorage.removeItem('request_type')
        },

        isAuthenticated() {
            return this.getToken() !== null;
        },
        getSessionId() {
            return localStorage.getItem('session_id');
        },
        hasAutoLoginParams(query) {
            return Object.keys(query).length !== 0 &&
                typeof query.username !== 'undefined' &&
                typeof query.api_token !== 'undefined';
        },
        isAutoLogin() {
            let urlParams = new URLSearchParams(window.location.search);
            return urlParams.has('username') &&
                urlParams.has('api_token') &&
                urlParams.has('api_token_expired');
        },
        isAutoLoginDoNotMatch() {
            const {
                username
            } = this.getUser();
            const token = localStorage.getItem('token');
            const expiration = localStorage.getItem('expiration');
            const urlParams = new URLSearchParams(window.location.search);

            return this.isAutoLogin() && (
                username !== urlParams.get('username') ||
                token !== urlParams.get('api_token') ||
                expiration !== urlParams.get('api_token_expired')
            )
        },
    };

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get() {
                return Vue.auth;
            }
        }
    })
}
